<template>
    <div class="leveled"><!-- klass detail-->

      
    <div id="componentBox" ref="componentBox">
      <div class="mark">PageKlass.vue</div>








<div id="starting" class="container relative">

        <div class="row relative">
          <div class="col col-1 no-pad relative">

            <div class="nav-side"  v-bind:style="getHeightOfApp">


              <div id="knob-prev" class="btn prev" @click="scrollTop()"></div>
              <div class="btn inactive"></div>
              <div id="knob-next" ref="knobnext" class="btn next" @click="nextLevel(progress)"></div>

            </div>

          </div>
          <div class="col col-11 no-pad">










<div id="level0">



      <div class="container bg-white mt-88 relative">

        <div class="row headline-section">
          <div class="col col-1 no-pad"></div>
          <div class="col col-11 no-pad">
            <h2>Welkom bij het lesprogramma <span class="blue-light">Samen Fris</span> over roken, vapen, alcohol drinken en blowen.</h2>
          </div>
        </div>
      </div>








       <div class="container bg-light-blue download-brief">
        <div class="row klas-list input-part">
          <div class="col col-1 no-pad"></div>
          <div class="col col-7 no-pad">
            <p class="norm">Deelname van een ouder is essentieel voor het slagen van de lessenserie. In deze eerste mail worden ouders op de hoogte van de lessenserie gehouden.
              <br>
              Voorbereidingen lesprogramma: Informeer alle ouders met een (digitale) brief en/of presentatie tijdens een ouderavond.
            </p>
            <div class="input-group-btn">
              <a :href="downPresentatie" class="btn btn-secondary download hvr-border-fade" target="_blank">Download (digitale) brief en presentatie  </a>
            </div>
          </div>
          <div class="col col-2 no-pad"></div>
        </div>
      </div>








      <div class="container bg-orange les-periode-1 klass-detail-block">
        <div class="row klas-list input-part">
          <div class="col col-1 no-pad"></div>
          <div class="col col-7 no-pad">
            <h6>VOORBEREIDING</h6>
            <h2>Informeer de ouders...</h2>
            <p class="norm"><strong>Over de start van het lesprogramma.</strong> Hoe ouders dit kunnen volgen en wat hun rol hierin is.</p>
          </div>
          <div class="col col-2 no-pad"><div class="envelop"></div></div>
        </div>
      </div>










      <div id="email-save-part" class="container bg-white klass-detail-block mailer">
        <div class="row klas-list input-part">
          <div class="col col-2 no-pad"></div>
          <div class="col col-9 no-pad">
            <h3>Voeg contacten van deze klas toe</h3>
            <h4>Emailadres ouders (graag email gevolgd door komma, maximaal 75 adressen)</h4>


              <div class="form-group">
                

                <!-- <textarea class="form-control" id="parentsEmails" rows="10" placeholder="ouder1@email.com, ouder2@email.com, ouder3@email.com"></textarea> -->


                

                <div
                  ref="emailInput"
                  contenteditable="true"
                  @input="highlightEmails"
                  @blur="syncText"
                  class="email-editor"
                ></div>



              </div>
              <h4>Bewaar deze maillijst in uw browser voor de mailings.</h4>
              <div class="input-group-btn">
               

                 <button class="btn btn-secondary hvr-border-fade" @click="saveEmails">Bewaar in deze browser</button>
                
  
              </div>



          </div>
          <div class="col col-1 no-pad"></div>
        </div>
      </div>



















      <div class="container bg-white klass-detail-block mt-20">
        <div class="row klas-list input-part pt-0">
          <div class="col col-2 no-pad"></div>
          <div class="col col-9 no-pad ">
            <h4 class="text-right bree-gray">eerste mail</h4>

              <div class="row inblock-border bg-lighter-blue">
                <div class="col col-8 no-pad">
                  <h6>LESPROGRAMMA SAMEN FRIS</h6>
                  <h3><b>Uw kind start een lesprogramma</b> over roken, vapen, alcohol drinken en blowen. <b>Wat is uw rol?</b></h3>
                </div>
                <div class="col col-4 no-pad"><div class="smoke"></div></div>
              </div>





          </div>
          <div class="col col-1 no-pad"></div>
        </div>

        <div class="row klas-list input-part pt-0">
          <div class="col col-12 no-pad text-center pseudo-envelop">
            <div class="input-group-btn">
              <img v-if="sendingStatus" class="sending-status" src="../../dist/img/loading.gif" >
              <div v-if="sendingFail" class="fail">
                <div class="svg-box">
                  <svg class="circular red-stroke">
                      <circle class="path" cx="75" cy="75" r="30" fill="none" stroke-width="2" stroke-miterlimit="10"/>
                  </svg>
                  <svg class="cross red-stroke">
                      <g transform="matrix(0.79961,8.65821e-32,8.39584e-32,0.79961,-502.652,-204.518)">
                          <path class="first-line" d="M634.087,300.805L673.361,261.53" fill="none"/>
                      </g>
                      <g transform="matrix(-1.28587e-16,-0.79961,0.79961,-1.28587e-16,-204.752,543.031)">
                          <path class="second-line" d="M634.087,300.805L673.361,261.53"/>
                      </g>
                  </svg>
                </div>
              </div>
              <button v-if="progress ==0" class="btn w-auto btn-secondary hvr-border-fade" v-on:click="sendEmail('email-1')">Stuur mail 1: Uw kind start!</button>                
                <div v-else class="btn w-auto btn-secondary off">Stuur mail 1: Uw kind start!<svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"><circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/><path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg></div>
              </div>
          </div>
        </div>
      </div>









</div>






      <!----- LEVEL 2 ------->
      <div v-if="progress >= 1" id="level1"> 
          
          <div v-if="openedEmails > 0">
             <!-----  ------->
            <div class="container relative">
              <div class="row between-section">
                <div class="col col-12 no-pad">
                  <h4 class="bree-gray">De herinneringsmail</h4>
                </div>
              </div>
            </div>

            <div class="container bg-white relative tealish-tab-mark enveloped">
              <div class="row headline-section2">
                <div class="col col-1 no-pad"></div>
                <div class="col col-10 no-pad">
                  <h6 class="grey tabb">DE EERSTE EMAIL NAAR DE OUDERS</h6>
                  <h2>Hoeveel ouders hebben de mail al gelezen? </h2>
                  <div class="number-of-parents">{{ openedEmails }}</div>
                  <h6 class="tealish tabb" v-if="openedEmails > 1">OUDERS HEBBEN DE MAIL GELEZEN</h6>
                  <h6 class="tealish tabb" v-if="openedEmails == 1">OUDER HEBBEN DE MAIL GELEZEN</h6>
                </div>
                <div class="col col-1 no-pad"></div>
              </div>
            </div>
          </div>
         





      </div>
      <!----- LEVEL 3 ------->
      <!----- if email1b enable <div v-if="progress >= 2" id="level2">------->
      <div v-if="progress >= 1" id="level2"><!-- if progress 2 -->



      <!-- KAHOOOT --->
      <div class="container bg-pale-orange les-periode-1 klass-detail-block mt-70">
        <div class="row klas-list input-part">
          <div class="col col-1 no-pad"></div>
          <div class="col col-8 no-pad">
            <h6>LES 1</h6>
            <h2>Het voorbereiden van <b>les 1</b></h2>

            <div class="logo-kahoot"><p>quiz over roken, vapen, alcohol drinken en blowen.</p></div>

             <button v-on:click="goToMaterial('les1')" class="btn w-auto btn-import-kahoot right-arrow hvr-border-fade">Naar lesmateriaal</button>


          </div>
          <div class="col col-3 no-pad"><div class="tea"></div></div>
        </div>
      </div>



      <div class="container bg-pale-orange les-periode-1 klass-detail-block mt-70">
        <div class="row klas-list input-part">
          <div class="col col-1 no-pad"></div>
          <div class="col col-8 no-pad">
            <h6>LES 1</h6>
            <h2>Resultaten van <b>Kahoot</b></h2>

            
            <div v-if="progress < 3" class="kah-up">
                <div @drop="_drop" @dragenter="_suppress" @dragover="_suppress">
                  <div class="row">
                    <div class="col-xs-12">
                      <form class="form-inline">
                        <div class="upload-btn-wrapper">
                          <button :class="{ active: hover }" class="btn w-auto btn-import-kahoot right-arrow hvr-border-fade">Upload Kahoot! Excel</button>
                          <input
                          @mouseover="hover = true"
                          @mouseleave="hover = false"
                          type="file"
                          class="form-control"
                          id="file"
                          :accept="SheetJSFT"
                          @change="_change" />
                        </div> 
                      </form>
                    </div>
                  </div>
                </div>
            </div>                          
            <div v-else class="kah-up">
                <div class="row">
                  <div class="col-xs-12">
                    <br><br>                    
                    <div class="btn w-auto btn-import-kahoot right-arrow off">Upload Kahoot! Excel<svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"><circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/><path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg></div>
                  </div>
                </div>
            </div>

          </div>
          <div class="col col-3 no-pad"></div>
        </div>
      </div>






      <!--- KAHOOOT UPloaded data -->
        <div v-if="kahoot.question_4" class="container bg-white klass-detail-block mt-20 pt-60">
        <div class="row klas-list input-part pt-0">
          <div class="col col-1 no-pad"></div>
          <div class="col col-10 no-pad">

              <div class="row inblock-border bg-green-blue">
                <div class="col col-xl-7 no-pad">
                  <h5 class="shade-box">Deel de Kahoot! resultaten met de ouders</h5>
                  <h3><b>Wat denkt de klas van<br>uw kind?</b> Bekijk de<br>antwoorden op de quiz</h3>
                </div>
                <div class="col col-xl-5 no-pad">

                  <div class="row">
                    <div class="col col-lg-6 df">
                      <div class="graph yellow dfb">
                        <div class="volume" :style="{ height: kahoot.question_4 + '%' }"></div>
                        <div class="graph-center"></div>
                      </div>
                    </div>
                    <div class="col col-lg-6 df">
                      <div class="graph blue dfb">
                        <div class="volume" :style="{ height: kahoot.question_7 + '%' }"></div>
                        <div class="graph-center"></div>
                      </div>
                    </div>
                  </div>

                  <div class="row kahoot-result">
                    <div class="col col-lg-6">
                      <h5>{{ kahoot.question_4 }}%</h5>
                      <p>Denk dat cannabis schadelijker is dan alcohol</p>
                    </div>
                    <div class="col col-lg-6">
                      <h5>{{ kahoot.question_7 }}%</h5>
                      <p>Zegt thuis geen regels te hebben</p>
                    </div>
                  </div>

                </div>
              </div>

            </div>
          <div class="col col-1 no-pad"></div>
        </div>


      </div>






      <div v-if="kahoot.question_4" class="row klas-list input-part pt-0">
          <div class="col col-12 no-pad text-center pseudo-envelop">
            <div class="input-group-btn relative">
              <img v-if="sendingStatus" class="sending-status" src="../../dist/img/loading.gif" >
              <div v-if="sendingFail" class="fail">
                <div class="svg-box">
                  <svg class="circular red-stroke">
                      <circle class="path" cx="75" cy="75" r="30" fill="none" stroke-width="2" stroke-miterlimit="10"/>
                  </svg>
                  <svg class="cross red-stroke">
                      <g transform="matrix(0.79961,8.65821e-32,8.39584e-32,0.79961,-502.652,-204.518)">
                          <path class="first-line" d="M634.087,300.805L673.361,261.53" fill="none"/>
                      </g>
                      <g transform="matrix(-1.28587e-16,-0.79961,0.79961,-1.28587e-16,-204.752,543.031)">
                          <path class="second-line" d="M634.087,300.805L673.361,261.53"/>
                      </g>
                  </svg>
                </div>
              </div>
              <button v-if="progress < 3" class="btn w-auto btn-secondary hvr-border-fade" v-on:click="sendEmail('email-2')">Stuur mail: Kahoot resultaten</button>
              
              <div v-else class="btn w-auto btn-secondary off">Stuur mail: Kahoot resultaten<svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"><circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/><path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg></div>
            </div>
          </div>
        </div>



      </div>









      <!----- LEVEL 3 ------->
      <div v-if="progress >= 3" id="level3"><!-- if progress 3 -->



      <!-- LES2 mat --->
      <div class="container bg-pale-orange les-periode-1 klass-detail-block mt-70">
        <div class="row klas-list input-part">
          <div class="col col-1 no-pad"></div>
          <div class="col col-8 no-pad">
            <h6>LES 2</h6>
            <h2>Het voorbereiden van <b>les 2</b></h2>
            <p class="pdbm">In les 2 werken de leerlingen aan een mindmap over de korte en lange termijn gevolgen van roken, vapen, alcohol drinken en blowen.</p>
            <button v-on:click="goToMaterial('les2')" class="btn w-auto btn-import-kahoot right-arrow hvr-border-fade">Naar lesmateriaal</button>
          </div>
          <div class="col col-3 no-pad"><div class="tea"></div></div>
        </div>
      </div>


          <!--- questions from students -->
      <div :class="{ 'theory' : kahoot.onderwijstype == 'theoretisch'}" class="container bg-light-blue download-brief questions-field">
        <div class="row klas-list input-part">
          <div class="col col-1 no-pad"></div>
          <div class="col col-10 no-pad">
            <h5>Noteer hier  de quizvragen die leerlingen in les 2 hebben bedacht voor de eindquiz.</h5>
            <div class="form-group">
                <textarea class="form-control" id="questions" rows="10">{{ kahoot.les2_questions }}</textarea>
              </div>
            <div class="input-group-btn">
              <button class="btn btn-secondary hvr-border-fade" v-on:click="saveQuestions(id)">Bewaar</button>
            </div>
          </div>
          <div class="col col-1 no-pad"></div>
        </div>
      </div>





      <!-- send mail les 2 -->
      <div class="container bg-white klass-detail-block mt-20 les2">
        <div class="row klas-list input-part pt-0">
          <div class="col col-1 no-pad"></div>
          <div class="col col-10 no-pad ">

            <div class="row no-pad no-mar">
              <div class="col col-6 no-pad"><h3 class="top-right">Na les 2</h3></div>
              <div class="col col-6 no-pad"><h4 class="text-right bree-gray">vierde mail</h4></div>
            </div>





              <div class="row inblock-border bg-lighter-blue">

                <div class="col col-7 no-pad">
                  <h5 class="shade-box">Informeer de ouders hoe zij zich kunnen gaan voorbereiden op de huiswerkopdracht.</h5>
                  <h3>Bereid u alvast voor<br> <b>op de huiswerk opdracht van uw kind.</b></h3>

                </div>
                <div class="col col-5 no-pad"><div class="cigareta"></div></div>
              </div>





          </div>
          <div class="col col-1 no-pad"></div>
        </div>

        <div class="row klas-list input-part pt-0">
          <div class="col col-12 no-pad text-center pseudo-envelop">
            <div class="input-group-btn">
                <img v-if="sendingStatus" class="sending-status" src="../../dist/img/loading.gif" >
                <div v-if="sendingFail" class="fail">
                <div class="svg-box">
                  <svg class="circular red-stroke">
                      <circle class="path" cx="75" cy="75" r="30" fill="none" stroke-width="2" stroke-miterlimit="10"/>
                  </svg>
                  <svg class="cross red-stroke">
                      <g transform="matrix(0.79961,8.65821e-32,8.39584e-32,0.79961,-502.652,-204.518)">
                          <path class="first-line" d="M634.087,300.805L673.361,261.53" fill="none"/>
                      </g>
                      <g transform="matrix(-1.28587e-16,-0.79961,0.79961,-1.28587e-16,-204.752,543.031)">
                          <path class="second-line" d="M634.087,300.805L673.361,261.53"/>
                      </g>
                  </svg>
                </div>
              </div>
                <button v-if="progress < 4" class="btn w-auto btn-secondary hvr-border-fade" v-on:click="sendEmail('email-3')">Stuur mail</button>
                
                <div v-else class="btn w-auto btn-secondary off">Stuur mail<svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"><circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/><path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg></div>
              </div>
          </div>
        </div>
      </div>





      </div>
      <!-- END level 4 -->







      <!----- LEVEL 4 ------->
      <div v-if="progress >= 4" id="level4">

      <!-- LES3 mat --->
      <div class="container bg-pale-orange les-periode-1 klass-detail-block mt-70">
        <div class="row klas-list input-part">
          <div class="col col-1 no-pad"></div>
          <div class="col col-8 no-pad">
            <h6>LES 3</h6>
            <h2>Het voorbereiden van <b>les 3</b></h2>
            <p class="pdbm">In de derde les bespreken de leerlingen stellingen over roken, vapen, alcohol drinken en blowen. Daarnaast wordt de huiswerkopdracht voorbereid”</p>
           
            <button v-on:click="goToMaterial('les3')" class="btn w-auto btn-import-kahoot right-arrow hvr-border-fade">Naar lesmateriaal</button>
          </div>
          <div class="col col-3 no-pad"><div class="tea"></div></div>
        </div>
      </div>


      <!-- send mail les 3 -->
      <div class="container bg-white klass-detail-block mt-20 les3">
        <div class="row klas-list input-part pt-0">
          <div class="col col-1 no-pad"></div>
          <div class="col col-10 no-pad ">

            <div class="row no-pad no-mar">
              <div class="col col-6 no-pad"><h3 class="top-right">Na les 3</h3></div>
              <div class="col col-6 no-pad"><h4 class="text-right bree-gray">vijfde mail</h4></div>
            </div>

            <div class="row inblock-border bg-pale-orange">
              <div class="col col-7 no-pad">
                <h5 class="shade-box">Informeer de ouders hoe zij samen met hun kind de huiswerkopdracht kunnen doen.</h5>
                <h3><b>Het is tijd voor de </b><br>huiswerkopdracht!</h3>
              </div>
              <div class="col col-5 no-pad"><div class="chating-kids"></div></div>
            </div>

          </div>
          <div class="col col-1 no-pad"></div>
        </div>

        <div class="row klas-list input-part pt-0">
          <div class="col col-12 no-pad text-center pseudo-envelop">
            <div class="input-group-btn">
                <img v-if="sendingStatus" class="sending-status" src="../../dist/img/loading.gif" >
                <div v-if="sendingFail" class="fail">
                <div class="svg-box">
                  <svg class="circular red-stroke">
                      <circle class="path" cx="75" cy="75" r="30" fill="none" stroke-width="2" stroke-miterlimit="10"/>
                  </svg>
                  <svg class="cross red-stroke">
                      <g transform="matrix(0.79961,8.65821e-32,8.39584e-32,0.79961,-502.652,-204.518)">
                          <path class="first-line" d="M634.087,300.805L673.361,261.53" fill="none"/>
                      </g>
                      <g transform="matrix(-1.28587e-16,-0.79961,0.79961,-1.28587e-16,-204.752,543.031)">
                          <path class="second-line" d="M634.087,300.805L673.361,261.53"/>
                      </g>
                  </svg>
                </div>
              </div>
                <button v-if="progress < 5" class="btn w-auto btn-secondary hvr-border-fade" v-on:click="sendEmail('email-4')">Stuur mail</button>
                
                <div v-else class="btn w-auto btn-secondary off">Stuur mail<svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"><circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/><path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg></div>
              </div>
          </div>
        </div>
      </div>



    </div>
    <!-- END level 4 -->






    <!----- LEVEL 5 ------->
    <div v-if="progress >= 5" id="level5">
      <!-- LES4 mat --->
      <div id="" class="container bg-pale-orange les-periode-1 klass-detail-block mt-70">
        <div class="row klas-list input-part">
          <div class="col col-1 no-pad"></div>
          <div class="col col-8 no-pad">
            <h6>LES 4</h6>
            <h2>Het voorbereiden van <b>les 4</b></h2>
            <p class="pdbm">Afronding en samenvatting van het lesprogramma.</p>
            
            <button v-on:click="goToMaterial('les4')" class="btn w-auto btn-import-kahoot right-arrow hvr-border-fade">Naar lesmateriaal</button>
          </div>
          <div class="col col-3 no-pad"><div class="tea"></div></div>
        </div>
      </div>


      <!-- send mail les 4 -->
      <div class="container bg-white klass-detail-block mt-20 les4">
        <div class="row klas-list input-part pt-0">
          <div class="col col-1 no-pad"></div>
          <div class="col col-10 no-pad ">

            <div class="row no-pad no-mar">
              <div class="col col-6 no-pad"><h3 class="top-right">Na les 4</h3></div>
              <div class="col col-6 no-pad"><h4 class="text-right bree-gray">zesde mail</h4></div>
            </div>

            <div class="row inblock-border bg-lighter-blue">
              <div class="col col-7 no-pad">
                <h5 class="shade-box">Informeer de ouders hoe zij verder kunnen en bedank hen voor deelname aan <b>Samen</b> Fris.</h5>
                <h3><b>Blijf in gesprek en</b><br>stel regels.</h3>
              </div>
              <div class="col col-5 no-pad"><div class="chating-kids blue"></div></div>
            </div>

          </div>
          <div class="col col-1 no-pad"></div>
        </div>

        <div class="row klas-list input-part pt-0">
          <div class="col col-12 no-pad text-center pseudo-envelop">
            <div class="input-group-btn">
                <img v-if="sendingStatus" class="sending-status" src="../../dist/img/loading.gif" >
                <div v-if="sendingFail" class="fail">
                <div class="svg-box">
                  <svg class="circular red-stroke">
                      <circle class="path" cx="75" cy="75" r="30" fill="none" stroke-width="2" stroke-miterlimit="10"/>
                  </svg>
                  <svg class="cross red-stroke">
                      <g transform="matrix(0.79961,8.65821e-32,8.39584e-32,0.79961,-502.652,-204.518)">
                          <path class="first-line" d="M634.087,300.805L673.361,261.53" fill="none"/>
                      </g>
                      <g transform="matrix(-1.28587e-16,-0.79961,0.79961,-1.28587e-16,-204.752,543.031)">
                          <path class="second-line" d="M634.087,300.805L673.361,261.53"/>
                      </g>
                  </svg>
                </div>
              </div>
                <button v-if="progress < 6" class="btn w-auto btn-secondary hvr-border-fade" v-on:click="sendEmail('email-5')">Stuur mail</button>
                
                <div v-else class="btn w-auto btn-secondary off">Stuur mail<svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"><circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/><path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg></div>
              </div>
          </div>
        </div>
      </div>


  </div>
    <!----- LEVEL 6 ------->
    <div v-if="progress >= 6" id="level6">
      <div id="end-les" class="container bg-pale-orange les-periode-1 klass-detail-block mt-70">
        <div class="row klas-list input-part">
          <div class="col col-1 no-pad"></div>
          <div class="col col-10 no-pad">
            <h6>LES 4</h6>
            <h2>Dit was het lesprogramma,<br><b>bedankt voor deelname.</b></h2>
          </div>
          <div class="col col-1 no-pad"></div>
        </div>
      </div>
    </div>
    <!-- end level 6 -->











</div>
</div>
</div>
</div>
</div>
</template>






<script>
import Vue from 'vue'
import XLSX from 'xlsx';
var VueScrollTo = require('vue-scrollto');
Vue.use(VueScrollTo);
const make_cols = refstr => Array(XLSX.utils.decode_range(refstr).e.c + 1).fill(0).map((x,i) => ({name:XLSX.utils.encode_col(i), key:i}));
const _SheetJSFT = [
  "xlsx", "xlsb", "xlsm", "xls", "xml", "csv", "txt", "ods", "fods", "uos", "sylk", "dif", "dbf", "prn", "qpw", "123", "wb*", "wq*", "html", "htm"
].map(function(x) { return "." + x; }).join(",");


   export default {
        name: 'Pageklass',
        props:['id'],


    

    data: function () {
        return {
          getHeightOfApp: { },
          //level:2,
          userdata:'',
          file: '',
          email2HTML: '',
          data: ["SheetJS".split(""), "1234567".split("")],
          cols: [
            {name:"A", key:0},
            {name:"B", key:1},
            {name:"C", key:2},
            {name:"D", key:3},
            {name:"E", key:4},
            {name:"F", key:5},
            {name:"G", key:6},
          ],
          SheetJSFT: _SheetJSFT,
          parentsEm: '',
          numberOfParents:0,
          kahoot:[],
          showPopup: false,
          questions:'',
          hover: false,
          downPresentatie: Vue.prototype.$hostname+"/downloads/Ouderbrief-presentatie.zip",
          downOneP: Vue.prototype.$hostname+"/wp/wp-content/uploads/2019/09/P_Docentenhandleidig_les1.pdf",
          downTwoP: Vue.prototype.$hostname+"/wp/wp-content/uploads/2019/09/P_Docentenhandleidig_les2_.pdf",
          downThreeP:Vue.prototype.$hostname+"/wp/wp-content/uploads/2019/09/P_Docentenhandleidig_les3.pdf",
          downFourP:Vue.prototype.$hostname+"/wp/wp-content/uploads/2019/09/P_Docentenhandleidig_les4.pdf",
          
          downOneT: Vue.prototype.$hostname+"/wp/wp-content/uploads/2019/09/T_Docentenhandleidig_les1_.pdf",
          downTwoT: Vue.prototype.$hostname+"/wp/wp-content/uploads/2019/09/T_Docentenhandleidig_les2.pdf",
          downThreeT:Vue.prototype.$hostname+"/wp/wp-content/uploads/2019/09/T_Docentenhandleidig_les3.pdf",
          downFourT:Vue.prototype.$hostname+"/wp/wp-content/uploads/2019/09/T_Docentenhandleidig_les4.pdf",

          downOne:'',
          downTwo:'',
          downThree:'',
          downFour:'',

          typClass:'',

          progress:0,
          sendingStatus : false,
          sendingFail : false,

          openedEmails:0,


          parentsEmails: "",
          errorMessage: "",
          validRegex: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/, // Email regex pattern
        }
    },

    created() {
        this.fetchData(this.id);
        //this.saveQuestions(this.id);
        this.fetchQuestion(this.id);
        this.getRightPdf(this.typClass);
        
    },

   
  

    mounted () {
      this.matchHeight();
      this.loadParents();
      //this.updateEditorContent();
       //this.setupObserver();
      
      
      
    },


    watch: {
      '$route' (to, from) {
        if(to !== from ) {
          //this.loadParents();
          this.fetchData(this.id);
          this.fetchQuestion(this.id);
          $("#knob-next").show();
          this.matchHeight();
          
        }
      },
      id(newID, oldID) {
        if (newID !== oldID) {
          this.loadParents(); // Reload emails when class ID changes
        }
      }
    },

    ////////////////
  



    
    methods: {



       getRightPdf(typClass){
        var self = this;
        //console.log(typClass);       
        if (self.typClass=='praktisch') {
            self.downOne = self.downOneP;
            self.downTwo = self.downTwoP;
            self.downThree = self.downThreeP;
            self.downFour = self.downFourP;
        }else{
            self.downOne = self.downOneT;
            self.downTwo = self.downTwoT;
            self.downThree = self.downThreeT;
            self.downFour = self.downFourT;

        }
       },


       goToMaterial(les){
        var self = this;
        if (self.typClass=='praktisch') {
          if (les=='les1') {
            self.$router.replace({ name: "praktisch", query: {goto: 'les1'} });
          }else if (les=='les2') {
            self.$router.replace({ name: "praktisch", query: {goto: 'les2'} });
          }else if (les=='les3') {
            self.$router.replace({ name: "praktisch", query: {goto: 'les3'} });
          }else if (les=='les4') {
            self.$router.replace({ name: "praktisch", query: {goto: 'les4'} });
          }
        }else{
          if (les=='les1') {
            self.$router.replace({ name: "theoretisch", query: {goto: 'les1'} });
          }else if (les=='les2') {
            self.$router.replace({ name: "theoretisch", query: {goto: 'les2'} });
          }else if (les=='les3') {
            self.$router.replace({ name: "theoretisch", query: {goto: 'les3'} });
          }else if (les=='les4') {
            self.$router.replace({ name: "theoretisch", query: {goto: 'les4'} });
          }

        }

       },


      
      
      matchHeight () {
          
          var heightString = $('#componentBox').height();
          $('.nav-side').height(heightString+300);  
        },

        scrollTop(){
          var elStart = document.getElementById("starting");
           
            $("#knob-next").show();
            this.$scrollTo(elStart, 400,{easing: 'ease',offset: -245});
        },
        nextLevel(progress){
          var self = this;  
               setTimeout(()=>{             
            const elLevel0 = document.getElementById("level0");
            const elLevel1 = document.getElementById("level1");
            const elLevel2 = document.getElementById("level2");
            const elLevel3 = document.getElementById("level3");
            const elLevel4 = document.getElementById("level4");
            const elLevel5 = document.getElementById("level5");
            const elLevel6 = document.getElementById("level6");
         

            switch ( progress ) {
              case '0':
                  //elLevel1.scrollIntoView();
                  self.$scrollTo(elLevel0, 500,{easing: 'ease-out',offset: 150});
                  break;
              case '1':
                  //elLevel1.scrollIntoView();
                  self.$scrollTo(elLevel1, 500,{easing: 'ease-out',offset: 50});
                  break;
              case '2':
                  //elLevel2.scrollIntoView();
                  self.$scrollTo(elLevel2, 500,{easing: 'ease-out',offset: -50});
                  break;
              case '3':
                  //elLevel3.scrollIntoView();
                  self.$scrollTo(elLevel3, 500,{easing: 'ease-out',offset:-65});
                  break;
              case '4':
                  //elLevel4.scrollIntoView();
                  self.$scrollTo(elLevel4, 500,{easing: 'ease-out',offset: 350});
                  break;
              case '5':
                  //elLevel5.scrollIntoView();
                  self.$scrollTo(elLevel5, 500,{easing: 'ease-out',offset: 350});
                  break;
              case '6':
                  //elLevel6.scrollIntoView();
                  self.$scrollTo(elLevel6, 500,{easing: 'ease-out',offset: 350});
                  $('#knob-next').hide();
                  break;

              
              }
self.matchHeight();
 },1000);

          
        },

        scrollToLevel(progress){
          var self = this;
          setTimeout(()=>{
                              
                      $('#knob-next').show();      
            const elLevel0 = document.getElementById("level0");
            const elLevel1 = document.getElementById("level1");
            const elLevel2 = document.getElementById("level2");
            const elLevel3 = document.getElementById("level3");
            const elLevel4 = document.getElementById("level4");
            const elLevel5 = document.getElementById("level5");
            const elLevel6 = document.getElementById("level6");
         

            switch ( progress ) {
              case '1':
                  //elLevel1.scrollIntoView();
                  self.$scrollTo(elLevel1, 500,{easing: 'ease-out',offset: -50});
                  break;
              case '2':
                  //elLevel2.scrollIntoView();
                  self.$scrollTo(elLevel2, 500,{easing: 'ease-out',offset: -50});
                  break;
              case '3':
                  //elLevel3.scrollIntoView();
                  self.$scrollTo(elLevel3, 500,{easing: 'ease-out',offset: -50});
                  break;
              case '4':
                  //elLevel4.scrollIntoView();
                  self.$scrollTo(elLevel4, 500,{easing: 'ease-out',offset: -50});
                  break;
              case '5':
                  //elLevel5.scrollIntoView();
                  self.$scrollTo(elLevel5, 500,{easing: 'ease-out',offset: -50});
                  break;
              case '6':
                  //elLevel6.scrollIntoView();
                  self.$scrollTo(elLevel6, 500,{easing: 'ease-out',offset: -50});
                  $('#knob-next').hide();
                  break;

              default:
                  //elLevel0.scrollIntoView();
                  self.$scrollTo(elLevel0, 500,{easing: 'ease-out',offset: -50});
                  break;
              }


self.matchHeight();
            console.log('progress = '+progress);
          },1000);
        },

        
/*
        saveEmails(id){
          console.log(this.id);
          var parentsEmails = $("#parentsEmails").val();
          var parentOfThisClass = this.id;
          localStorage.removeItem('classID'+this.id)
          localStorage.removeItem(parentOfThisClass);
          localStorage.setItem(parentOfThisClass,parentsEmails);
          this.loadParents();
        },
*/






/*

        saveEmails(id) {
            console.log(this.id);

            // Retrieve email addresses from the textarea
            var parentsEmails = $("#parentsEmails").val();

            // Validate the email addresses before proceeding
            if (!this.validateEmails(parentsEmails)) {
                // If validation fails, stop execution
                alert("Validation failed. Emails are not saved.");
                return;
            }

            // If validation passes, proceed with saving emails
            var parentOfThisClass = this.id;

            // Remove existing entries from localStorage
            localStorage.removeItem('classID' + this.id);
            localStorage.removeItem(parentOfThisClass);

            // Save the valid email addresses in localStorage
            localStorage.setItem(parentOfThisClass, parentsEmails);

            // Load the updated parents' data (if applicable)
            this.loadParents();

            console.log("Emails saved successfully.");
        },

      */

      

highlightEmails(event) {
      let el = this.$refs.emailInput;
      let text = el.innerText.trim();

      // Only validate after comma or semicolon
      if (text.endsWith(",") || text.endsWith(";")) {
        this.validateAndFormatEmails(el);
      }
    },

    validateAndFormatEmails(el) {
        let emails = el.innerText
            .replace(/\s/g, "") // Remove spaces
            .split(/,|;/) // Split by comma or semicolon
            .filter(email => email); // Remove empty values

        this.errorMessage = emails.length > 75 ? "Maximaal 75 e-mailadressen toegestaan!" : "";

        el.innerHTML = emails
            .map((email, index) => 
                this.validRegex.test(email) 
                    ? (index < 75 ? `<span>${email},</span>` : `<span class="invalid-email">${email},</span>`)
                    : `<span class="invalid-email">${email},</span>`
            )
            .join(" ");

        this.parentsEmails = emails.join(", "); // Update model
        this.setCaretToEnd(el); // Keep cursor at the end
    },

    setCaretToEnd(el) {
      let range = document.createRange();
      let sel = window.getSelection();
      range.selectNodeContents(el);
      range.collapse(false); // Move cursor to end
      sel.removeAllRanges();
      sel.addRange(range);
    },

    saveEmails() {
      if (this.errorMessage) {
        alert("Corrigeer de e-mailadressen voordat u opslaat.");
        return;
      }

      localStorage.setItem(`class_${this.id}_emails`, this.parentsEmails);
      console.log(`Emails saved for class ${this.id}:`, this.parentsEmails);
      console.log("Emails saved successfully!");
    },

    loadParents() {
      let storedEmails = localStorage.getItem(`class_${this.id}_emails`);
      if (storedEmails !== null) {
        this.parentsEmails = storedEmails;
        this.$refs.emailInput.innerText = storedEmails; // Ensure UI updates
        console.log(`Loaded emails for class ${this.id}:`, storedEmails);
      } else {
        this.parentsEmails = ""; // Ensure no previous class data is used
        this.$refs.emailInput.innerText = "";
        console.log(`No emails found for class ${this.id}. Setting empty.`);
      }
    },

    syncText() {
      this.parentsEmails = this.$refs.emailInput.innerText;
    },


















    validateEmails() {
        let emails = this.parentsEmails.replace(/\s/g, "").split(/,|;/).filter(email => email);
        let invalidEmails = emails.filter(email => !this.validRegex.test(email));

        if (emails.length > 75) {
            this.errorMessage = "Maximaal 75 e-mailadressen toegestaan!";
        } else if (invalidEmails.length > 0) {
            this.errorMessage = `Ongeldig e-mailadres: ${invalidEmails.join(", ")}`;
        } else {
            this.errorMessage = "";
        }
    },
  
    
   
    

  
      



/*

        loadParents(){
          var self = this;
          var archive = {}, // Notice change here
        keys = Object.keys(localStorage),
        i = keys.length;

    while ( i-- ) {
        archive[ keys[i] ] = localStorage.getItem( keys[i] );

        console.log(archive[ self.id ]);// this returns this: some@email.com, ome@email.com,ome@email.com,ome@email.com,ome@email.com
        self.parentsEm = archive[ self.id ];
        $("#parentsEmails").val(archive[ self.id ]);


    }

    if (archive[ self.id ]) {
      var arr = archive[ self.id ].split('@'); 
      if (arr.length==1) {
        localStorage.getItem( self.id );
        if (!localStorage.getItem( self.id )) {
          self.numberOfParents=0;
        }
      }
      self.numberOfParents = arr.length-1;
    }else{
      self.numberOfParents = 0; 
    }

        },
        */

        getPromise(object) {
              let type = object.content_type.toLowerCase();
              if (type === "episode") {
                return isEpisode(object.content_url);
              }
              if (type === "episode") {
                return isSection(data);
              }
            },
/*
        validateEmails(string) {
            var regex = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
            var result = string.replace(/\s/g, "").split(/,|;/);        
            
            console.log(result.length);  /// number of email addresses
            if (result.length>75) {
                alert('Max. 75 mail adressen!');
                return false;
              }


            for(var i = 0;i < result.length;i++) {
                if(!regex.test(result[i])) {
                    return false;
                }
            }       
            return true;
        },

*/








        saveMsgId(msgid,klassID){
          var self = this;
          let content = {
            msgid:msgid
          }
          self.axios({
                      method: 'put', 
                      url: Vue.prototype.$hostname+'/wp/wp-json/wp/v2/classes/'+klassID,
                      data: content,
                      headers: {
                        'Content-Type': 'application/json',
                        'accept': 'application/json',
                        'Authorization': 'Bearer '+localStorage.getItem("token")
                      }
                    }).then(response => {
                        }).then(function(post){
                            console.log('msgid inserted = '+msgid); 
                        });
        },

        saveOpenedEmailsDb(klassID,opened){
          var self = this;
          let content = {
            opened:opened
          }
          self.axios({
                      method: 'put', 
                      url: Vue.prototype.$hostname+'/wp/wp-json/wp/v2/classes/'+klassID,
                      data: content,
                      headers: {
                        'Content-Type': 'application/json',
                        'accept': 'application/json',
                        'Authorization': 'Bearer '+localStorage.getItem("token")
                      }
                    }).then(response => {
                        }).then(function(post){
                            console.log('opened emails-1 updated'); 
                        });
        },






        getOpenedEmails(msgid) {
          var self = this;
          var klassID = this.id;
          var teacherEmail = localStorage.getItem("teacherEmail");

          $.ajax({
            url: Vue.prototype.$hostname + "/opened.php?msgid=" + msgid + "&docentemail=" + teacherEmail,
            dataType: "text",
            success: function (data) {
              try {
                let json = JSON.parse(data); // Attempt to parse JSON

                if (json.error) {
                  console.warn("Mailgun API error:", json.error);
                  return;
                }

                var openedMailgun = json.opened || 0; // Fallback to 0 if not present
                if (openedMailgun > 0) {
                  self.saveOpenedEmailsDb(klassID, openedMailgun);
                  self.openedEmails = openedMailgun;
                }
              } catch (e) {
                console.error("Error parsing JSON from Mailgun:", e, data);
              }
            },
            error: function (jqXHR, textStatus, errorThrown) {
              console.error("AJAX error:", textStatus, errorThrown);
            },
          });
        },





        getMessageId(teacherEmail){
          var self = this;
          var klassID = this.id;
          setTimeout(() => { 

            $.ajax({  
                   url: Vue.prototype.$hostname+"/msgid.php?docentemail="+teacherEmail,
                   dataType: "text",
                    success: function(data) {
                          var json = $.parseJSON(data); 
                          //self.openedEmails = json.opened;//opened' => $f, 'msgid
                          self.saveMsgId(json.msgid,klassID);

                        }
                      });

          },10000);
          
        },






        sendEmail(emailNum){

          //console.log(localStorage.getItem('classID'+this.id));
          
          var self = this;
          //var parentsEmails = $("#parentsEmails").val();
          //var parentsEmails = this.parentsEmails
          var teacherEmail = localStorage.getItem('teacherEmail');
          var emailSlug = emailNum;
          var klassID = this.id;
          //var self=this;
          console.log("teacherEmail = "+teacherEmail);
          console.log("parentsEmails = "+self.parentsEmails);
          console.log("parentsEmails2 = ",localStorage.getItem(self.id));
          ///////////
          //if ( self.validateEmails(parentsEmails) && parentsEmails ) { 
          
          if (self.parentsEmails) {

              self.sendingStatus = true;
              self.sendingFail = false;
              if (emailSlug=="email-2") {           
                $.ajax({  
                   url: Vue.prototype.$hostname+"/wp/wp-json/wp/v2/classes/"+klassID,
                   dataType: "text",
                    success: function(data) {
                          var json = $.parseJSON(data);                          
                          ///////////////////////
                          var q4 = json.question_4;
                          var q7 = json.question_7;
                          var q7max = json.q7_max_title;


                          var q4cd10 = json.q4_cd10;
                          var q4ef10 = json.q4_ef10;
                          var q4gh10 = json.q4_gh10;
                          var q4ij10 = json.q4_ij10;
                          var q4max2 = [q4ef10, q4cd10, q4gh10, q4ij10];
                          var q4max;

                      if (parseInt(Math.max(...q4max2)) == parseInt(q4cd10)) {
                        q4max = 'cd10';
                      }else if(parseInt(Math.max(...q4max2)) == parseInt(q4ef10)){
                        q4max = 'ef10';
                      }else if(parseInt(Math.max(...q4max2)) == parseInt(q4gh10)){
                        q4max = 'gh10';
                      }else if(parseInt(Math.max(...q4max2)) == parseInt(q4ij10)){
                        q4max = 'ij10';
                      }



                          let content = { 
                             emailSlug: emailSlug,
                             klassID: self.id,
                             teacherEmail: teacherEmail,
                             //parentsEmails: parentsEmails,
                             parentsEmails: self.parentsEmails,
                             q4:q4,
                             q7:q7,
                             q7max:q7max,
                             q4max:q4max
                          };
                
                          console.log('sending email 2');
                 
                          self.axios({
                            method: 'post', 
                            url: Vue.prototype.$hostname+'/wp/wp-content/themes/aero/send-email.php',
                            data: content,
                            headers: {
                              'Content-Type': 'application/json',
                              'accept': 'application/json',
                              'Authorization': 'Bearer '+localStorage.getItem("token")
                            }
                          }).then(response => {
                             
                          }).then(function(post){
                              console.log('Email 2 sent!');
                              
                              self.updateProgress(self.id,3);
                              self.sendingStatus = false;
                              self.sendingFail = false;
                          }).catch(function(){
                                console.log('FAILURE!!');
                                self.sendingStatus = false;
                                self.sendingFail = true;
                              });
                        ///
                        
                    }
                });
              }else{

                let content = { 
                   emailSlug: emailSlug,
                   klassID: self.id,
                   teacherEmail: teacherEmail,
                   //parentsEmails: parentsEmails
                   parentsEmails: self.parentsEmails 
                };
                      
                console.log('sending email '+emailSlug);
                       
                this.axios({
                  method: 'post', 
                  url: Vue.prototype.$hostname+'/wp/wp-content/themes/aero/send-email.php',
                  data: content,
                  headers: {
                    'Content-Type': 'application/json',
                    'accept': 'application/json',
                    'Authorization': 'Bearer '+localStorage.getItem("token")
                  }
                }).then(response => {
                    console.log('SUCCESS!!');
                    console.log(response.data);
                     if (emailSlug=='email-1') {
                      self.updateProgress(self.id,1);// les 1
                      self.getMessageId(teacherEmail);
                    }else if(emailSlug=='email1b'){
                      self.updateProgress(self.id,2);
                    }else if(emailSlug=='email-2'){
                      self.updateProgress(self.id,3);
                    }else if(emailSlug=='email-3'){//les 2 
                      self.updateProgress(self.id,4);
                    }else if(emailSlug=='email-4'){//les 3
                      self.updateProgress(self.id,5);
                    }else if(emailSlug=='email-5'){//les 4
                      self.updateProgress(self.id,6);
                    }

                    self.sendingStatus = false;
                    self.sendingFail = false;
                }).catch(function(){
                      console.log('FAILURE!!');
                      self.sendingStatus = false;
                      self.sendingFail = true;
                    });


              }
                    
        
                  /// END create email 2
                }else{//if not parent emails
                  self.sendingFail = true;
                  
                  let elToScr = document.getElementById('email-save-part');
                  self.$scrollTo(elToScr, 900,{easing: 'ease-out',offset: -20});
                  setTimeout(() => { 
                    alert('Er gaat iets fout met het invoeren van de e-mailadressen. Controleer de e-mailadressen op spelling en check of ze door komma’s gescheiden zijn.');
                  },1300);
                }


        },






    

  //////////////////
  //// xls
_suppress(evt) { evt.stopPropagation(); evt.preventDefault(); },
    _drop(evt) {
      evt.stopPropagation(); evt.preventDefault();
      const files = evt.dataTransfer.files;
      if(files && files[0]) this._file(files[0]);
    },
    _change(evt) {
      var self = this;
      const files = evt.target.files;
      if(files && files[0]) this._file(files[0]);

          localStorage.setItem("klassID",this.id);
          self.showPopup = true;
    },
    _export(evt) {
      /* convert state to workbook */
      const ws = XLSX.utils.aoa_to_sheet(this.data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "SheetJS");
      /* generate file and send to client */
      XLSX.writeFile(wb, "sheetjs.xlsx");
    },
    _file(file) {
      var self = this;
      localStorage.setItem("klassID",this.id);
      console.log(self.id);
      /* Boilerplate to set up FileReader */
      const reader = new FileReader();
      reader.onload = (e) => {
        /* Parse data */
        
                
                /////////// sheet 0
                      const bstr = e.target.result;
                      const wb = XLSX.read(bstr, {type:'binary'});
                      const wsname = wb.SheetNames[0];
                      const ws = wb.Sheets[wsname];
                      //Convert array of arrays
                      ws['!ref'] = 'A1:J100';
                      const data = XLSX.utils.sheet_to_json(ws, {header:1});
                      //Update state
                      //self.data = data;


                     // console.log('data: ');
                      //console.log(data);
                      var players = data[3][1];
                      //console.log(players);
                      //$numberOfPlayers = $excel_arr[4]["B"];
                ///////////////






/*
///// debuger

console.log("Available Sheets:", wb.SheetNames);

const sheetName = "1 Quiz"; // Specify the desired sheet name
const ws2 = wb.Sheets[sheetName]; // Get the worksheet by name

if (!ws2) {
  console.error(`Sheet "${sheetName}" not found.`);
} else {

  console.log("Raw Sheet Object for 1 Quiz:", ws2);
console.log(`Sheet Range for "1 Quiz": ${ws2['!ref']}`);

ws2['!ref'] = 'A1:J100'; // Adjust the range to cover all rows and columns



const range = XLSX.utils.decode_range(ws2['!ref']); // Decode the adjusted range
const extractedData = [];
for (let R = range.s.r; R <= range.e.r; ++R) {
  const row = [];
  for (let C = range.s.c; C <= range.e.c; ++C) {
    const cell = ws2[XLSX.utils.encode_cell({ r: R, c: C })];
    row.push(cell ? cell.v : null); // Push the value or null if cell is empty
  }
  extractedData.push(row);
}
console.log("Complete Extracted Data from 1 Quiz:", extractedData);
  


}
/// end debuger
*/






                    
                     const wsname3 = wb.SheetNames[3]; // Get the name of the desired sheet
                      const ws3 = wb.Sheets[wsname3]; // Get the worksheet

                      // Redefine the range to include all rows and columns
                      ws3['!ref'] = 'A1:J100'; 

                      // Convert the sheet to JSON
                      const data3 = XLSX.utils.sheet_to_json(ws3, { header: 1 });
                      //console.log('data3:');
                      //console.log(data3);

                      // Parse the specific cells
                      var q1_cd10 = data3[9][2];
                      if (data3[9][2] == null) { q1_cd10 = 0; }

                      var q1_ef10 = data3[9][4];
                      if (data3[9][4] == null) { q1_ef10 = 0; }

                      var q1_gh10 = data3[9][6];
                      if (data3[9][6] == null) { q1_gh10 = 0; }

                      var q1_ij10 = data3[9][8];
                      if (data3[9][8] == null) { q1_ij10 = 0; }

                      // Create an array of maximum values
                      var q1max = [q1_ef10, q1_cd10, q1_gh10, q1_ij10];
                      console.log('q1max: ');
                      console.log(q1max);

                      // Determine the maximum title
                      var q1_max_title;
                      if (parseInt(Math.max(...q1max)) == parseInt(q1_cd10)) {
                          q1_max_title = data3[7][3];
                      } else if (parseInt(Math.max(...q1max)) == parseInt(q1_ef10)) {
                          q1_max_title = data3[7][5];
                      } else if (parseInt(Math.max(...q1max)) == parseInt(q1_gh10)) {
                          q1_max_title = data3[7][7];
                      } else if (parseInt(Math.max(...q1max)) == parseInt(q1_ij10)) {
                          q1_max_title = data3[7][9];
                      }

                      q1_max_title = q1_max_title.replace(/"/g, "");
                      console.log('q1 max = ' + Math.max(...q1max) + ' of ' + q1_max_title);
                     
                ///////////////











                /////////// sheet 4 ->q2
                      const wsname4 = wb.SheetNames[4];
                      const ws4 = wb.Sheets[wsname4];
                      ws4['!ref'] = 'A1:J100';
                      const data4 = XLSX.utils.sheet_to_json(ws4, {header:1});
                      
                     // console.log('data4:');
                      //console.log(data4);
                      
                       var q2_cd10 = data4[9][2];
                      if (data4[9][2]==null) {q2_cd10 =0;}
                     
                      
                      var q2_ef10 = data4[9][4]; 
                      if (data4[9][4]==null) {q2_ef10=0;}

                      var q2_gh10 = data4[9][6]; 
                      if (data4[9][6]==null) {q2_gh10=0;}

                      var q2_ij10 = data4[9][8];
                      if (data4[9][8]==null) {q2_ij10 = 0;}

                      var q2max = [q2_ef10, q2_cd10, q2_gh10, q2_ij10];

                      var q2_max_title;
                      if (parseInt(Math.max(...q2max)) == parseInt(q2_cd10)) {
                        q2_max_title = data4[7][3];
                      }else if(parseInt(Math.max(...q2max)) == parseInt(q2_ef10)){
                        q2_max_title = data4[7][5];
                      }else if(parseInt(Math.max(...q2max)) == parseInt(q2_gh10)){
                        q2_max_title = data4[7][7];
                      }else if(parseInt(Math.max(...q2max)) == parseInt(q2_ij10)){
                        q2_max_title = data4[7][9];
                      }
                      q2_max_title = q2_max_title.replace(/"/g, "");


                      console.log('q2 max = '+Math.max(...q2max)+' of '+q2_max_title);
                ///////////////


                /////////// sheet 5 ->q3
                      const wsname5 = wb.SheetNames[5];
                      const ws5 = wb.Sheets[wsname5];
                      ws5['!ref'] = 'A1:J100';
                      const data5 = XLSX.utils.sheet_to_json(ws5, {header:1});
                      
                       var q3_cd10 = data5[9][2];
                      if (data5[9][2]==null) {q3_cd10 =0;}
                     // console.log('q3_cd10 = '+ q3_cd10);
                      
                      var q3_ef10 = data5[9][4]; 
                      if (data5[9][4]==null) {q3_ef10=0;}
                     // console.log('q3_ef10 = '+q3_ef10);

                      var q3_gh10 = data5[9][6]; 
                      if (data5[9][6]==null) {q3_gh10=0;}
                     // console.log('q3_gh10 = '+q3_gh10);

                      var q3_ij10 = data5[9][8];
                      if (data5[9][8]==null) {q3_ij10 = 0;}
                     // console.log( 'q3_ij10 = '+q3_ij10);

                      var q3max = [q3_ef10, q3_cd10, q3_gh10, q3_ij10];
                      
                      var q3_max_title;
                      if (parseInt(Math.max(...q3max)) == parseInt(q3_cd10)) {
                        q3_max_title = 'cd10';
                      }else if(parseInt(Math.max(...q3max)) == parseInt(q3_ef10)){
                        q3_max_title = 'ef10';
                      }else if(parseInt(Math.max(...q3max)) == parseInt(q3_gh10)){
                        q3_max_title = 'gh10';
                      }else if(parseInt(Math.max(...q3max)) == parseInt(q3_ij10)){
                        q3_max_title = 'ij10';
                      }
                      q3_max_title = q3_max_title.replace(/"/g, "");
                      console.log('q3 max = '+Math.max(...q3max)+' of '+q3_max_title);
                ///////////////


                /////////// sheet 6 ->q4
                      const wsname6 = wb.SheetNames[6];
                      const ws6 = wb.Sheets[wsname6];
                      ws6['!ref'] = 'A1:J100';
                      const data6 = XLSX.utils.sheet_to_json(ws6, {header:1});
                      
                       var q4_cd10 = data6[9][2];
                      if (data6[9][2]==null) {q4_cd10 =0;}
                     // console.log('q4_cd10 = '+ q4_cd10);
                      
                      var q4_ef10 = data6[9][4]; 
                      if (data6[9][4]==null) {q4_ef10=0;}
                      //console.log('q4_ef10 = '+q4_ef10);

                      var q4_gh10 = data6[9][6]; 
                      if (data6[9][6]==null) {q4_gh10=0;}
                      //console.log('q4_gh10 = '+q4_gh10);

                      var q4_ij10 = data6[9][8];
                      if (data6[9][8]==null) {q4_ij10 = 0;}
                      //console.log( 'q4_ij10 = '+q4_ij10);

                      var q4max = [q4_ef10, q4_cd10, q4_gh10, q4_ij10];
                      console.log('q4 max = '+Math.max(...q4max));
                ///////////////


                /////////// sheet 7 ->q5
                      const wsname7 = wb.SheetNames[7];
                      const ws7 = wb.Sheets[wsname7];
                      ws7['!ref'] = 'A1:J100';
                      const data7 = XLSX.utils.sheet_to_json(ws7, {header:1});
                      
                      
                       var q5_cd10 = data7[9][2];
                      if (data7[9][2]==null) {q5_cd10 =0;}
                     // console.log('q5_cd10 = '+ q5_cd10);
                      
                      var q5_ef10 = data7[9][4]; 
                      if (data7[9][4]==null) {q5_ef10=0;}
                     // console.log('q5_ef10 = '+q5_ef10);

                      var q5_gh10 = data7[9][6]; 
                      if (data7[9][6]==null) {q5_gh10=0;}
                     // console.log('q5_gh10 = '+q5_gh10);

                      var q5_ij10 = data7[9][8];
                      if (data7[9][8]==null) {q5_ij10 = 0;}
                     // console.log( 'q5_ij10 = '+q5_ij10);

                      var q5max = [q5_ef10, q5_cd10, q5_gh10, q5_ij10];

                      var q5_max_title;
                      if (parseInt(Math.max(...q5max)) == parseInt(q5_cd10)) {
                        q5_max_title = data7[7][3];
                      }else if(parseInt(Math.max(...q5max)) == parseInt(q5_ef10)){
                        q5_max_title = data7[7][5];
                      }else if(parseInt(Math.max(...q5max)) == parseInt(q5_gh10)){
                        q5_max_title = data7[7][7];
                      }else if(parseInt(Math.max(...q5max)) == parseInt(q5_ij10)){
                        q5_max_title = data7[7][9];
                      }
                      q5_max_title = q5_max_title.replace(/"/g, "");
                      console.log('q5 max = '+Math.max(...q5max)+' of '+q5_max_title);
                ///////////////



                /////////// sheet 8 ->q6
                      const wsname8 = wb.SheetNames[8];
                      const ws8 = wb.Sheets[wsname8];
                      ws8['!ref'] = 'A1:J100';
                      const data8 = XLSX.utils.sheet_to_json(ws8, {header:1});
                      //console.log(data8);
                      
                       var q6_cd10 = data8[9][2];
                      if (data8[9][2]==null) {q6_cd10 =0;}
                     // console.log('q6_cd10 = '+ q6_cd10);
                      
                      var q6_ef10 = data8[9][4]; 
                      if (data8[9][4]==null) {q6_ef10=0;}
                      //console.log('q6_ef10 = '+q6_ef10);

                      var q6_gh10 = data8[9][6]; 
                      if (data8[9][6]==null) {q6_gh10=0;}
                      //console.log('q6_gh10 = '+q6_gh10);

                      var q6_ij10 = data8[9][8];
                      if (data8[9][8]==null) {q6_ij10 = 0;}
                     // console.log( 'q6_ij10 = '+q6_ij10);

                      var q6max = [q6_ef10, q6_cd10, q6_gh10, q6_ij10];
                      var q6_max_title;
                      if (parseInt(Math.max(...q6max)) == parseInt(q6_cd10)) {
                        q6_max_title = data8[7][3];
                      }else if(parseInt(Math.max(...q6max)) == parseInt(q6_ef10)){
                        q6_max_title = data8[7][5];
                      }else if(parseInt(Math.max(...q6max)) == parseInt(q6_gh10)){
                        q6_max_title = data8[7][7];
                      }else if(parseInt(Math.max(...q6max)) == parseInt(q6_ij10)){
                        q6_max_title = data8[7][9];
                      }
                      q6_max_title = q6_max_title.replace(/"/g, "");
                      console.log('q6 max = '+Math.max(...q6max)+' of '+q6_max_title);
                ///////////////



                /////////// sheet 9 ->q7
                      const wsname9 = wb.SheetNames[9];
                      const ws9 = wb.Sheets[wsname9];
                      ws9['!ref'] = 'A1:J100';
                      const data9 = XLSX.utils.sheet_to_json(ws9, {header:1});
                      
                       var q7_cd10 = data9[9][2];
                      if (data9[9][2]==null) {q7_cd10 =0;}
                      //console.log('q7_cd10 = '+ q7_cd10);
                      
                      var q7_ef10 = data9[9][4]; 
                      if (data9[9][4]==null) {q7_ef10=0;}
                      //console.log('q7_ef10 = '+q7_ef10);

                      var q7_gh10 = data9[9][6]; 
                      if (data9[9][6]==null) {q7_gh10=0;}
                      //console.log('q7_gh10 = '+q7_gh10);

                      var q7_ij10 = data9[9][8];
                      if (data9[9][8]==null) {q7_ij10 = 0;}
                     // console.log( 'q7_ij10 = '+q7_ij10);

                      var q7max = [q7_ef10, q7_cd10, q7_gh10, q7_ij10];
                      var q7_max_title;
                      if (parseInt(Math.max(...q7max)) == parseInt(q7_cd10)) {
                        q7_max_title = 'cd10';
                      }else if(parseInt(Math.max(...q7max)) == parseInt(q7_ef10)){
                        q7_max_title = 'ef10';
                      }else if(parseInt(Math.max(...q7max)) == parseInt(q7_gh10)){
                        q7_max_title = 'gh10';
                      }else if(parseInt(Math.max(...q7max)) == parseInt(q7_ij10)){
                        q7_max_title = 'ij10';
                      }
                      q7_max_title = q7_max_title.replace(/"/g, "");
                      console.log('q7 max = '+Math.max(...q7max)+' of '+q7_max_title);
                      
                ///////////////


                /////////// sheet 10 ->q8
                      const wsname10 = wb.SheetNames[10];
                      const ws10 = wb.Sheets[wsname10];
                      ws10['!ref'] = 'A1:J100';
                      const data10 = XLSX.utils.sheet_to_json(ws10, {header:1});
                      //console.log(data10);
                      
                       var q8_cd10 = data10[9][2];
                      if (data10[9][2]==null) {q8_cd10 =0;}
                      //console.log('q8_cd10 = '+ q8_cd10);
                      
                      var q8_ef10 = data10[9][4]; 
                      if (data10[9][4]==null) {q8_ef10=0;}
                     // console.log('q8_ef10 = '+q8_ef10);

                      var q8_gh10 = data10[9][6]; 
                      if (data10[9][6]==null) {q8_gh10=0;}
                      //console.log('q8_gh10 = '+q8_gh10);

                      var q8_ij10 = data10[9][8];
                      if (data10[9][8]==null) {q8_ij10 = 0;}
                     // console.log( 'q8_ij10 = '+q8_ij10);

                      var q8max = [q8_ef10, q8_cd10, q8_gh10, q8_ij10];
                      var q8_max_title;
                      if (parseInt(Math.max(...q8max)) == parseInt(q8_cd10)) {
                        q8_max_title = data10[7][3];
                      }else if(parseInt(Math.max(...q8max)) == parseInt(q8_ef10)){
                        q8_max_title = data10[7][5];
                      }else if(parseInt(Math.max(...q8max)) == parseInt(q8_gh10)){
                        q8_max_title = data10[7][7];
                      }else if(parseInt(Math.max(...q8max)) == parseInt(q8_ij10)){
                        q8_max_title = data10[7][9];
                      }
                      q8_max_title = q8_max_title.replace(/"/g, "");
                      console.log('q8 max = '+Math.max(...q8max)+' of '+q8_max_title);
                ///////////////





               


                //   players
                var numberOfPlayers = players.substring(0, players.length - 8);
                var isOnePlayer = players.substring(0, 2);
                if (parseInt(isOnePlayer)==1) {
                   numberOfPlayers = players.substring(0, players.length - 7);
                }


                //console.log('numberOfPlayers = '+numberOfPlayers);


                var q1Result = Math.round(parseInt(Math.max(...q1max))/parseInt(numberOfPlayers)*100);
                //console.log('q1Result = '+q1Result);

                var q2Result = Math.round(parseInt(Math.max(...q2max))/parseInt(numberOfPlayers)*100);
                //console.log('q2Result = '+q2Result);

                var q3Result = Math.round(parseInt(Math.max(...q3max))/parseInt(numberOfPlayers)*100);
                //console.log('q3Result = '+q3Result);

                var q4Result = Math.round(parseInt(Math.max(...q4max))/parseInt(numberOfPlayers)*100);
                //console.log('q4Result = '+q4Result);

                var q5Result = Math.round(parseInt(Math.max(...q5max))/parseInt(numberOfPlayers)*100);
               // console.log('q5Result = '+q5Result);

                var q6Result = Math.round(parseInt(Math.max(...q6max))/parseInt(numberOfPlayers)*100);
                //console.log('q6Result = '+q6Result);

                var q7Result = Math.round(parseInt(Math.max(...q7max))/parseInt(numberOfPlayers)*100);
                //console.log('q7Result = '+q7Result);

                var q8Result = Math.round(parseInt(Math.max(...q8max))/parseInt(numberOfPlayers)*100);
                //console.log('q8Result = '+q8Result);
                
                /// mame data -> generuj email
                //////////////////////////////
          
                //var post_data = "slug=email-2&g1="+q4Result+"&g2="+q7Result+"&klassid="+self.id;
                

                //$(".modal-body").html('<iframe width="430" height="100%" frameborder="0" scrolling="no" allowtransparency="true" src="'+Vue.prototype.$hostname+'/admin/gen-email2.php?'+post_data+'"></iframe>');
                
                //////////////////////////
                // save kahoot data to class
 

                self.insertKahoot(self.id,numberOfPlayers,q1Result,q2Result,q3Result,q4Result,q5Result,q6Result,q7Result,q8Result,q4_cd10,q4_ef10,q4_gh10,q4_ij10,q7_cd10,q7_ef10,q7_gh10,q7_ij10,q1_max_title,q2_max_title,q5_max_title,q6_max_title,q8_max_title,q7_max_title,q3_max_title);
                
                // END save kahoot data to class


                
                 









        //this.cols = make_cols(ws['!ref']);
      };
      reader.readAsBinaryString(file);
    },


/////// end xls
  ///////////////////





    insertKahoot: function(classid,players,q1,q2,q3,q4,q5,q6,q7,q8,q4_cd10,q4_ef10,q4_gh10,q4_ij10,q7_cd10,q7_ef10,q7_gh10,q7_ij10,q1_max_title,q2_max_title,q5_max_title,q6_max_title,q8_max_title,q7_max_title,q3_max_title) {
            var self = this;
          if (localStorage["token"]) {
            if(localStorage.getItem("role") == "teacher") {
                  let content = {
                    number_of_players:players,
                    question_1:q1,
                    question_2:q2,
                    question_3:q3,
                    question_4:q4,
                    question_5:q5,
                    question_6:q6,
                    question_7:q7,
                    question_8:q8,
                    q4_cd10:q4_cd10,
                    q4_ef10:q4_ef10,
                    q4_gh10:q4_gh10,
                    q4_ij10:q4_ij10,
                    q7_cd10:q7_cd10,
                    q7_ef10:q7_ef10,
                    q7_gh10:q7_gh10,
                    q7_ij10:q7_ij10,
                    q1_max_title:q1_max_title,
                    q2_max_title:q2_max_title,
                    q5_max_title:q5_max_title,
                    q6_max_title:q6_max_title,
                    q7_max_title:q7_max_title,
                    q8_max_title:q8_max_title,
                    q3_max_title:q3_max_title                 
                  };

                  self.axios({
                      method: 'put', 
                      url: Vue.prototype.$hostname+'/wp/wp-json/wp/v2/classes/'+classid,
                      data: content,
                      headers: {
                        'Content-Type': 'application/json',
                        'accept': 'application/json',
                        'Authorization': 'Bearer '+localStorage.getItem("token")
                      }
                    }).then(response => {

                          //this.items.splice(index, 1);/// odobere stare 
                          //this.items.push(response.data); // prida nove  
                          this.kahoot = response.data;  // get data 
                        }).then(function(post){
                            console.log('kahoot data updated');
                            
                            
                        });

            }
          }
        },

        fetchData(id){
          const params = {
            author: this.authorIdVue
          };
          var self = this;
          self.axios.get(Vue.prototype.$hostname+"/wp/wp-json/wp/v2/classes/"+id,{ params }).then(response => {
            this.kahoot = response.data;
            this.typClass = response.data.onderwijstype;
            localStorage.setItem("classType",response.data.onderwijstype);
            this.getRightPdf(this.typClass);
            this.progress = response.data.progress;
            this.scrollToLevel(this.progress);
            self.getOpenedEmails(response.data.msgid);
            self.openedEmails = response.data.opened;
//console.log(this.progress);
          });
        },



        fetchQuestion(id){
          const params = {
            author: this.authorIdVue
          };
          var self = this;
          this.axios.get(Vue.prototype.$hostname+"/wp/wp-json/wp/v2/classes/"+id,{ params }).then(response => {
            this.questions = response.data.les2_questions;
            $("#questions").val(this.questions);

          });
        },

       



        saveQuestions(classID){
          var self = this;
            if (localStorage["token"]) {
            if(localStorage.getItem("role") == "teacher") {
                  
              var questions = $("#questions").val();
                  let content = {
                    les2_questions:questions    
                  };

                  self.axios({
                      method: 'put', 
                      url: Vue.prototype.$hostname+'/wp/wp-json/wp/v2/classes/'+classID,
                      data: content,
                      headers: {
                        'Content-Type': 'application/json',
                        'accept': 'application/json',
                        'Authorization': 'Bearer '+localStorage.getItem("token")
                      }
                    }).then(response => { 
                          this.questions = response.data; 
                        }).then(function(post){
                            console.log('questions saved');                            
                        });

            }
          }

        },



        updateProgress(classID,progress){
          var self = this;
            if (localStorage["token"]) {
            if(localStorage.getItem("role") == "teacher") {
                  
             
                  let content = {
                    progress:progress    
                  };

                  self.axios({
                      method: 'put', 
                      url: Vue.prototype.$hostname+'/wp/wp-json/wp/v2/classes/'+classID,
                      data: content,
                      headers: {
                        'Content-Type': 'application/json',
                        'accept': 'application/json',
                        'Authorization': 'Bearer '+localStorage.getItem("token")
                      }
                    }).then(response => { 
                          this.progress = response.data.progress; 
                        }).then(function(post){
                            console.log('Progress saved');                            
                        });

            }
          }
        }













    }//end methods





}


        
    

</script>
<style lang="scss">
  .modal-body{
    display: block;
    position: fixed;
    bottom: 100px;
    right: 100px;
    z-index: 999;
    height: 654px;
    width: 412px;
  }

.btn.off{
  .checkmark__circle {
    stroke-dasharray: 166;
    stroke-dashoffset: 166;
    stroke-width: 2;
    stroke-miterlimit: 10;
    stroke: #7ac142;
    fill: none;
    animation: stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;
  }

  .checkmark {
    position: absolute;
    top: -67px;
    right: -22px;
    background-color: transparent!important;
    border: none!important;
    width: 56px;
    height: 56px;
    border-radius: 50%;
    display: block;
    stroke-width: 2;
    stroke: #fff;
    stroke-miterlimit: 10;
    margin: 10% auto;
    box-shadow: inset 0px 0px 0px #7ac142;
    animation: fill .4s ease-in-out .4s forwards, scale .3s ease-in-out .9s both;
  }

  .checkmark__check {
    transform-origin: 50% 50%;
    stroke-dasharray: 48;
    stroke-dashoffset: 48;
    animation: stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards;
  }

  @keyframes stroke {
    100% {
      stroke-dashoffset: 0;
    }
  }
  @keyframes scale {
    0%, 100% {
      transform: none;
    }
    50% {
      transform: scale3d(1.1, 1.1, 1);
    }
  }
  @keyframes fill {
    100% {
      box-shadow: inset 0px 0px 0px 30px #7ac142;
    }
  }
}



.email-editor {
  min-height: 200px;
  padding: 10px;
  border: 1px solid #ccc;
  font-size: 16px;
  outline: none;
  white-space: pre-wrap;
}
.invalid-email {
  color: red;
  font-weight: bold;
}
.error-text {
  color: red;
  font-weight: bold;
  margin-top: 10px;
}

</style>